import { useLocation } from 'react-router';

import { parseSearch } from '@jane/shared/util';

export const useQuery = <
  T extends Record<string, any> = Record<string, any>,
>() => {
  const location = useLocation();

  return parseSearch<T>(location.search);
};
